import React, { useState } from "react";
import {
  Button,
  SaveButton,
  useCreate,
  useNotify,
  FormWithRedirect,
  useTranslate,
  useRefresh,
} from "react-admin";
import IconContentAdd from "@material-ui/icons/Add";
import IconCancel from "@material-ui/icons/Cancel";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormFieldDealers from "./FormFieldDealers";

function CreateDealers(props) {
  const refresh = useRefresh();
  const translate = useTranslate();
  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate("dealers");
  const notify = useNotify();
  // const form = useForm()

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async (values) => {
    create(
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          // Update the comment form to target the newly created post
          // Updating the ReferenceInput value will force it to reload the available posts
          // form.change("id", data.id)
          setShowDialog(false);
          notify("ra.notification.created");
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, "error");
        },
      }
    );
  };

  return (
    <>
      <Button
        onClick={handleClick}
        label='resources.settings.labels.new_dealer'
        style={{ textTransform: "capitalize" }}
      >
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate("resources.settings.labels.new_dealer")}
      >
        <DialogTitle>
          {translate("resources.settings.labels.new_dealer")}
        </DialogTitle>

        <FormWithRedirect
          resource='dealers'
          save={(values) => handleSubmit(values)}
          initialValues={{ auto_receipt_day: [] }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => {
            return (
              <>
                <DialogContent>
                  <FormFieldDealers {...props} />
                </DialogContent>
                <DialogActions>
                  <Button
                    label='ra.action.cancel'
                    onClick={handleCloseClick}
                    disabled={loading}
                  >
                    <IconCancel />
                  </Button>
                  <SaveButton
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    pristine={pristine}
                    saving={saving}
                    disabled={loading}
                  />
                </DialogActions>
              </>
            );
          }}
        />
      </Dialog>
    </>
  );
}

export default CreateDealers;
